import { BookingCalendarEvent } from "@models/services/booking";
import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

import bookingSlice from "./booking.slice";
import drawerSlice from "./drawer.slice";

type initialType = {
  calendarEvents: BookingCalendarEvent[];
  tempEvents: BookingCalendarEvent[];
};

const initialState: initialType = {
  calendarEvents: [],
  tempEvents: [],
};

type bookingCalendarSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const setCalendarEvents: bookingCalendarSliceReducer<BookingCalendarEvent[]> = (
  state,
  action
) => {
  state.calendarEvents = action.payload;
};

const setTempEvents: bookingCalendarSliceReducer<BookingCalendarEvent[]> = (
  state,
  action
) => {
  state.tempEvents = action.payload;
};

export const bookingCalendarSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(bookingSlice.actions.flush, state => {
      state.tempEvents = [];
    });
    builder.addCase(drawerSlice.actions.removeDrawerBookingState, state => {
      state.tempEvents = [];
    });
  },
  initialState,
  name: "bookingCalendar",
  reducers: {
    setCalendarEvents,
    setTempEvents,
  },
});

export default bookingCalendarSlice;
